import { motion } from "framer-motion";
import { DeliveryIcon, PremiumIcon, CustomIcon, QualityIcon } from "../Icons";
import { homeValueProps } from "../../data/homeLuxury";

const iconMap = {
  magnetic: PremiumIcon,
  custom: CustomIcon,
  shipping: DeliveryIcon,
  corporate: QualityIcon,
};

export default function HomeValueStrip() {
  return (
    <section className="home-value-strip" aria-label="Why Rencin Gifting">
      <ul className="home-value-strip__grid">
        {homeValueProps.map((row, index) => {
          const Icon = iconMap[row.key] || PremiumIcon;
          return (
            <motion.li
              key={row.key}
              className="home-value-strip__item"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-5%" }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
            >
              <span className="home-value-strip__icon" aria-hidden>
                <Icon size={28} color="currentColor" />
              </span>
              <div>
                <h2 className="home-value-strip__title">{row.title}</h2>
                <p className="home-value-strip__text">{row.text}</p>
              </div>
            </motion.li>
          );
        })}
      </ul>
    </section>
  );
}
